export default __webpack_public_path__ + "static/media/game-categories.1350eab9.svg";